import { Box } from "@mui/material";
import { t } from "i18next";
import { formatCurrency } from "../../../../components/common/PriceDisplay";
import BaseTable from "../../../../components/table/BaseTable";
import { useCustomerBookingsDetails } from "../../../../services/bookingsService";
import DateService from "../../../../services/dateService";
import { BookingManageButton } from "../../../BookingPage/BookingManageButton";
import { BookingStatusText } from "../../../BookingPage/BookingStatusText";
import InfoIcon from "@mui/icons-material/Info";
import FiaskoEditDialog from "../../../../components/dialog/FiaskoEditDialog/FiaskoEditDialog";
import { useDialogBetter } from "../../../../hooks/useDialogBetter";

const HEADERS = [
    // t("clients.ClientPassportBookingTable.bookingNr"),
    t("clients.ClientPassportBookingTable.investment"),
    t("clients.ClientPassportBookingTable.price"),
    t("clients.ClientPassportBookingTable.productNumbers"),
    t("clients.ClientPassportBookingTable.productTypes"),
    t("clients.ClientPassportBookingTable.startDate"),
    t("clients.ClientPassportBookingTable.endDate"),
    t("clients.ClientPassportBookingTable.creator"),
    t("clients.ClientPassportBookingTable.status"),
    t("clients.ClientPassportBookingTable.manage"),
];

export function ClientPassportBookingsTable({ customerId, investmentId, maxHeight }) {
    const params = new URLSearchParams();
    if (investmentId) {
        params.set("investment", investmentId);
    }

    const { openDialog: openFiaskoDialog } = useDialogBetter();
    const handleOpenFiaskoDialog = (bookingId, reasonId, reasonNote) => {
        openFiaskoDialog({
            Component: FiaskoEditDialog,
            componentProps: {
            bookingId: bookingId,
            reasonId: reasonId,
            reasonNote: reasonNote,
            },
        });
        };

    const { data: customerBookings, isLoading, isFetching } = useCustomerBookingsDetails(customerId, params, {
        select: (data) => {
            // this is done on the front cause backend acts up
            // FIXME: this is so terrible im sorry for whoever has to deal with this
            const seenBookingNumbers = new Set();

            return data.results
                .filter((customerBooking) => {
                    if (seenBookingNumbers.has(customerBooking.booking_nr)) {
                        return false;
                    }
                    seenBookingNumbers.add(customerBooking.booking_nr);
                    return true;
                })
                .map((customerBooking) => {
                    const productNumbers = customerBooking.product_number.split("; ").join("\n")
                    const productTypes = customerBooking.product_type.split("; ").join("\n");
                    const prices = customerBooking.gross_price
                        .split("; ")
                        .map((price) => formatCurrency(price))
                        .join("\n");

                    return {
                        rowId: customerBooking.booking_nr,
                        data: [
                            // customerBooking.booking_nr,
                            customerBooking.investment.investment_name_sales,
                            prices,
                            productNumbers,
                            productTypes,
                            DateService.convertDatetimeFromBackendToFormatYYYYMMDD(
                                customerBooking.start_date,
                            ),
                            DateService.convertDatetimeFromBackendToFormatYYYYMMDD(
                                customerBooking.end_date,
                            ),
                            customerBooking.creator,
                            customerBooking.booking_status?.status_key === "Cancelled" && customerBooking.status.status_key !== "RemovedFromBooking" ? (
                            <div style={{display: "flex", justifyContent: "center"}}> 
                                <BookingStatusText
                                status={customerBooking.booking_status}
                            />
                                <InfoIcon style={{cursor: "pointer", marginLeft: "5px"}} onClick={()=>handleOpenFiaskoDialog(customerBooking.booking_id, customerBooking.reason?.id, customerBooking.booking_status_note)}/>
                            </div>) :
                            (<BookingStatusText
                                status={
                                    customerBooking.status.status_key === "RemovedFromBooking"
                                        ? customerBooking.status
                                        : customerBooking.booking_status
                                }
                            />),
                            <BookingManageButton bookingId={customerBooking.booking_id} />,
                        ],
                    };
                });
        },
    });


    return (
        <Box sx={{ maxHeight: maxHeight || 200, overflow: "auto", borderRadius: 1 }}>
            <BaseTable
                showLoader={isLoading || isFetching}
                stickyHeader={true}
                headers={HEADERS}
                rows={customerBookings || []}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                // ensure no columns are hidden
                hiddenColumns={[]}
                // no row selection for this static table
                selectedRows={[]}
            />
        </Box>
    );
}
